import {createAction} from 'redux-actions';
import * as ACTION from '../constants';

export const createWarehouse = createAction(ACTION.CREATE_WAREHOUSE.REQUEST, (params) => ({...params}));
export const clearState = createAction(ACTION.CLEAR_STATE);
